module.exports = __webpack_public_path__ + "img/savings-cloud-m-2.2c87a884.png";